import { createContext } from 'react';
export const OverlayLoaderTID = 'async-backdrop';
const noop = ()=>{};
export const OverlayContext = createContext({
    isTestMode: false,
    getHasOpenBottomSheet: ()=>false,
    getOpenedModals: ()=>[],
    showModal: async ()=>undefined,
    showConfirmAction: async ()=>Promise.resolve(),
    hideModal: noop,
    hideAllModals: noop,
    startLoader: noop,
    stopLoader: noop,
    showErrorToast: noop,
    showSuccessToast: noop,
    showWarningToast: noop,
    showInfoToast: noop,
    showPersistentToast: ()=>noop,
    showToast: noop,
    showBottomSheet: noop,
    pushBottomSheetPage: noop,
    popBottomSheetPage: noop,
    removeBottomSheetPage: noop,
    hideBottomSheet: noop
});
